export default {
  computed: {
    $currentUser () {
      return this.$store.state.user.currentUser
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/currentUser.js